import { Button, Checkbox, Collapse, Drawer } from 'antd';
import React, { useState } from 'react';
import { Col, Row, Container, ListGroup } from 'react-bootstrap';

import iconoFiltrar from '../../../img/icon_filtrar.svg';
import iconoOrdenar from '../../../img/icon_ordenar.svg';

import './mercadoPublico.css'

const { Panel } = Collapse;

const FiltroResponsive = ({ categorias, categoriaSeleccionada, setCategoria, ordenarTab }) => {

    const [visible, setVisible] = useState(false);
    const [ordenarMobile, setOrdenarMobile] = useState(false);

    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };    
    
    const handleShowOrdenar = () => {
        setOrdenarMobile(true);
    }

    const handleCloseOrdenar = () => {
        setOrdenarMobile(false);
    }

    const changeOrdenar = (value) => {
        ordenarTab.changeOrdenarVehiculos(value);
    }

    return (
        <Col className="bg-white pr-0" xs={12} sm={12} md={5} lg={4} xl={3}>
            <Row className="d-md-none my-md-4 button-mobile-of">
                <Col xs={6} className="px-0">
                    <Button variant="outline-light" onClick={handleShowOrdenar} className="mobile-buttons-mercado bold-title-hyundai f-responsive border-bottom-v border-right-v h-100 w-100 py-3">
                    <img src={iconoOrdenar} className="pr-2" alt="Ordenar" />Ordenar por</Button>
                </Col>                
                <Drawer
                    className="drawer-mobile-mp"
                    title={<h6 className="bold-title-hyundai f-18">Ordenar por</h6>}
                    placement="left"
                    closable={true}
                    onClose={handleCloseOrdenar}
                    visible={ordenarMobile}
                    key="left"
                    zIndex={1030}
                >
                    <Container fluid >
                        <Row>
                            <Col xs={12} className="px-0 my-auto">
                                <ListGroup className="list-ordenar-mp" role="tablist" onSelect={changeOrdenar}>
                                    <ListGroup.Item eventKey="a-z" action role="tab" className="f-responsive">A - z</ListGroup.Item>
                                    <ListGroup.Item eventKey="z-a" action role="tab" className="f-responsive">Z - a</ListGroup.Item>
                                    <ListGroup.Item eventKey="mayor-menor" action role="tab" className="f-responsive">Mayor precio - Menor precio</ListGroup.Item>
                                    <ListGroup.Item eventKey="menor-mayor" action role="tab" className="f-responsive">Menor precio - Mayor precio</ListGroup.Item>
                                </ListGroup>
                            </Col>
                        </Row>                                
                    </Container>
                </Drawer>
                <Col xs={6} className="px-0">
                    <Button variant="outline-light" className="mobile-buttons-mercado bold-title-hyundai f-responsive border-bottom-v h-100 w-100 py-3" onClick={showDrawer}>
                    <img src={iconoFiltrar} className="pr-2" alt="Filtrar" />Filtrar</Button>
                </Col>
                <Drawer
                    title={<h6 className="bold-title-hyundai f-18">Filtrar</h6>}
                    placement="left"
                    closable={true}
                    onClose={onClose}
                    visible={visible}
                    className="drawer-mercadoP"
                >
                    <Row>
                        <Col xs={12} className="px-0">
                            <Filtro categorias={categorias} categoriaSeleccionada={categoriaSeleccionada} setCategoria={setCategoria} />
                        </Col>
                    </Row>

                </Drawer>
            </Row>
            <div className="d-none d-md-block">
                <Filtro categorias={categorias} categoriaSeleccionada={categoriaSeleccionada} setCategoria={setCategoria} />
            </div>
        </Col>);
};

const Filtro = ({ categorias, categoriaSeleccionada, setCategoria }) => {

    const handleChangeCategoria = (value) => {
        let valor = value[value.length - 1] === undefined ? 0 : value[value.length - 1];

        setCategoria(valor.toString())
    }

    return (
        <Collapse defaultActiveKey={['categorias']} className="bg-white" bordered={false}>
            <Panel header={<h5 className="bold-title-hyundai f-responsive mt-1 mt-md-0">Linea de vehículos</h5>} key="categorias">
                <Checkbox.Group onChange={handleChangeCategoria} value={categoriaSeleccionada.toString()}>
                    {categorias && categorias.length > 0 && categorias.map((categoria, index) =>
                        <Row key={index}>
                            <Col>
                                <Checkbox value={categoria.idCategoria} className="parrafo-hyundai font-size-filtro f-responsive">{categoria.Nombre}</Checkbox>
                            </Col>
                        </Row>
                    )}

                </Checkbox.Group>
            </Panel>
        </Collapse>
    )
}

export default FiltroResponsive;